var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDispatched(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9984 15.2002C13.8821 15.2002 14.5984 14.4839 14.5984 13.6002C14.5984 12.7166 13.8821 12.0002 12.9984 12.0002C12.1148 12.0002 11.3984 12.7166 11.3984 13.6002C11.3984 14.4839 12.1148 15.2002 12.9984 15.2002Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99844 15.2002C5.88209 15.2002 6.59844 14.4839 6.59844 13.6002C6.59844 12.7166 5.88209 12.0002 4.99844 12.0002C4.11478 12.0002 3.39844 12.7166 3.39844 13.6002C3.39844 14.4839 4.11478 15.2002 4.99844 15.2002Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.60015V9.55775C1 11.4633 1 12.4161 1.5856 13.0081C1.9752 13.4017 2.5224 13.5337 3.4 13.5777M9.3416 2.40015C10.072 2.64015 10.6456 3.21935 10.8824 3.95775C11 4.32255 11 4.77375 11 5.67775C11 6.27935 11 6.58015 11.0784 6.82335C11.1555 7.06523 11.2888 7.28542 11.4673 7.46591C11.6458 7.64639 11.8646 7.78204 12.1056 7.86175C12.3464 7.94095 12.644 7.94095 13.24 7.94095H17V9.55775C17 11.4633 17 12.4161 16.4144 13.0081C16.0248 13.4017 15.4776 13.5337 14.6 13.5777M6.6 13.6001H11.4",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.00005H12.4568C13.6216 4.00005 14.2032 4.00005 14.6768 4.28325C15.1512 4.56565 15.4272 5.07845 15.9792 6.10405L17 8.00005M5.2616 4.80005L6.4504 3.86085C7.0832 3.36005 7.4 3.11045 7.4 2.80005M7.4 2.80005C7.4 2.48965 7.0832 2.24005 6.4504 1.73925L5.2616 0.800049M7.4 2.80005H1",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatched);
export default __webpack_public_path__ + "static/media/dispatched.3e5810018df563bcb290110c5c926c3b.svg";
export { ForwardRef as ReactComponent };